export const thresholdValue = (state, data) => {
    state.thresholdConfigData = data;
};

export const setSelectedTaskDetails = (state, rsp) => {
    if (rsp && !rsp.taskDetails) {
        rsp.taskDetails = [];
    }
    state.selectedTaskDetails = rsp;
};

export const setAllTasks = (state, rsp) => {
    state.allTasks = rsp;
};
export const setFiltredTasks = (state, rsp) => {
    state.filtredTasks = rsp;
};

export const setInitialDiagramData = (state, rsp) => {
    state.initialDiagramData = rsp;
};

export const setAllDataModelList = (state, payload) => {
    state.allDataModelList = payload;
};

export const setThresholds = (state, rsp) => {
    state.defaultThresholds = rsp;
};

export const setFilterObject = (state, payload) => {
    state.filterObject = payload;
};

export const setDataModelFilter = (state, payload) => {
    state.dataModelFilter = payload;
};

export const setSearchInSearchFilter = (state, payload) => {
    state.searchInSearchFilter = payload;
};

export const setCurrentPluginData = (state, payload) => {
    state.currentPluginData = payload;
};

export const setTaskDetailsById = (state, data) => {
    state.taskDetailsById = data.data;
};

export const setStatsPerLevels = (state, data) => {
    state.statsPerLevels = data;
};

export const setFilteredData = (state, data) => {
    state.filteredData = data;
};

export const setSelectedProcessReports = (state, payload) => {
    state.selectedProcessReports[payload.pageType] = payload.process;
};

export const setSelectedProcessStatistics = (state, payload) => {
    state.selectedProcessStatistics = payload;
};

export const setAppMatrixUncompletedTasksInfo = (state, data) => {
    state.appMatrixUncompletedTasks = data;
};

export const setNrOfResults = (state, data) => {
    state.nrOfResults = data;
};

export const setDataToExport = (state, data) => {
    state.dataToExport = data || {};
};
